import { LOTTERY_STATUS } from '@/constants';
import { estimatedShippingDateText, eventStatusLabel, showEstimatedShippingDate } from '@/features/lottery/utils';
import { Format } from '@/lib/dateFns';
import { LotteryEventList as CommonLotteryEventList, formatDateCommon } from '@monorepo/common';
import type { LotteryEvent } from '../../types';

type LotteryEventListProps = {
  lotteryEventList: Array<LotteryEvent>;
};

function LotteryEventList({ lotteryEventList }: LotteryEventListProps) {
  return (
    <CommonLotteryEventList
      lotteryEventList={lotteryEventList}
      variant='raffle'
      isSubImage={false}
      isLabelButton={true}
      LOTTERY_STATUS={LOTTERY_STATUS}
      estimatedShippingDateText={estimatedShippingDateText}
      eventStatusLabel={eventStatusLabel}
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      showEstimatedShippingDate={showEstimatedShippingDate as any}
      Format={Format}
      formatDateCommon={formatDateCommon}
    />
  );
}

export default LotteryEventList;
